var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47727 2 2 6.47727 2 12C2 17.5227 6.47727 22 12 22C17.5227 22 22 17.5227 22 12C22 6.47727 17.5227 2 12 2ZM11.5455 6.54545C11.3043 6.54545 11.0731 6.64123 10.9026 6.81172C10.7321 6.98221 10.6364 7.21344 10.6364 7.45455C10.6364 7.69565 10.7321 7.92688 10.9026 8.09737C11.0731 8.26786 11.3043 8.36364 11.5455 8.36364H12C12.2411 8.36364 12.4723 8.26786 12.6428 8.09737C12.8133 7.92688 12.9091 7.69565 12.9091 7.45455C12.9091 7.21344 12.8133 6.98221 12.6428 6.81172C12.4723 6.64123 12.2411 6.54545 12 6.54545H11.5455ZM10.1818 10.1818C9.94071 10.1818 9.70948 10.2776 9.53899 10.4481C9.36851 10.6186 9.27273 10.8498 9.27273 11.0909C9.27273 11.332 9.36851 11.5632 9.53899 11.7337C9.70948 11.9042 9.94071 12 10.1818 12H11.0909V14.7273H10.1818C9.94071 14.7273 9.70948 14.8231 9.53899 14.9935C9.36851 15.164 9.27273 15.3953 9.27273 15.6364C9.27273 15.8775 9.36851 16.1087 9.53899 16.2792C9.70948 16.4497 9.94071 16.5455 10.1818 16.5455H13.8182C14.0593 16.5455 14.2905 16.4497 14.461 16.2792C14.6315 16.1087 14.7273 15.8775 14.7273 15.6364C14.7273 15.3953 14.6315 15.164 14.461 14.9935C14.2905 14.8231 14.0593 14.7273 13.8182 14.7273H12.9091V11.0909C12.9091 10.8498 12.8133 10.6186 12.6428 10.4481C12.4723 10.2776 12.2411 10.1818 12 10.1818H10.1818Z",
    fill: "#409CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info_filled.9ab16c14d8519ca03084c6185e19ca05.svg";
export { ForwardRef as ReactComponent };